import Hosts from '../../../Hosts';

const object_type = 'store/category/product'
const object_type2 = 'store/category/product/next'

const api_crud_base = Hosts.SIMCore_API
const api_crud_route = `${Hosts.SIMCore_API}/${object_type}`
const api_list_route = (companycode) => `${Hosts.SIMCore_API}/${object_type}/${companycode}`
const api_list_order = (companycode) => `${Hosts.SIMCore_API}/${object_type2}/${companycode}/order`

const base_endpoint = '/store_category'

const endpoints = {
    base: base_endpoint,
    regist: `${base_endpoint}_regist`,
    list: `${base_endpoint}_list`,
    //view: `${base_endpoint}_view`,
    view: `${base_endpoint}`,
}

const data_interface = {
    id: '',
    info: {
        companycode: '',
        name: '',
        description: '',
        bgColor: '',
        borderColor: '',
        media: {
            image: [], 
            doc: []
        },
        status: true,
        order: 0,
        language: []
    }
}

export {
    endpoints,
    object_type,
    api_crud_base,
    api_crud_route,
    data_interface,
    api_list_route,
    api_list_order
}